module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"chooseTenantCard.title.default":"Choose Tenant","chooseTenantCard.subtitle.default":"Please choose a tenant","chooseTenantCard.subtitle.none":"No tenants available","chooseTenantCard.contact":"Please contact support"}}')
  delete Component.options._Ctor
}
